import { Address, PagingReq, PagingResData, ResCode } from './baseDefine';
import request from '@/utils/request';
export interface GetAddress extends PagingReq {
    address: Address;
    searchType: number;
}
export interface AddressesRes {
    code: ResCode;
    msg: string;
    data: GetAddressesRes;
}
export interface GetAddressesRes {
    addressesData: AddressesData;
}
export interface AddressesData extends PagingResData {
    list: Address[];
}
export function getAddresses(req: GetAddress): Promise<AddressesRes> {
    return request.post<AddressesRes>('/api/address/getAddresses', req);
}
